<template>
    <el-breadcrumb separator="/">
        <transition-group name="breadcrumb">
            <el-breadcrumb-item v-for="(item) in levelList" :key="item.path">
                <span v-if="item.redirect==='noredirect'">{{item.meta.title}}</span>
                <router-link v-else :to="item.path">{{item.meta.title}}</router-link>
            </el-breadcrumb-item>
        </transition-group>
    </el-breadcrumb>
</template>

<script>
    import { getGlobalConf } from '@/utils/grocer';
    export default {
        data () {
            return {
                levelList: []
            };
        },
        watch: {
            $route () {
                this.getBreadcrumb();
            }
        },
        created () {
            this.getBreadcrumb();
        },
        methods: {
            getBreadcrumb () {
                let matched = this.$route.matched.filter(item => item.name);
                // let ROUTER_BASE_PATH = '/bpm';
                let ROUTER_BASE_PATH = getGlobalConf().routerBasePath;
                // console.log(ROUTER_BASE_PATH);
                // if(ROUTER_BASE_PATH){
                //   ROUTER_BASE_PATH="/"+ROUTER_BASE_PATH;
                // }
                // let matched = this.$route.matched;
                const first = matched[0];
                if (first && first.name && first.name.trim().toLocaleLowerCase() !== 'workspace'.toLocaleLowerCase()) {
                    matched = [{path: ROUTER_BASE_PATH + '/workspace/workbench', meta: { title: '工作台' }}].concat(matched);
                    // matched = [{path: ROUTER_BASE_PATH + '/workspace/todoList', meta: { title: '待办事项' }}].concat(matched);
                }
                this.levelList = matched;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb/Breadcrumb.vue